module.exports = __webpack_public_path__ + "img/da_03.d11dbe2a.png";